import React, { useEffect, useRef, useState } from 'react';
import {
  Grid,
  Stack,
  Typography,
  Box,
  Button,
  Modal,
  Divider,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Tab,

  CircularProgress
} from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import moment from 'moment';
// import { htmlToText } from 'html-to-text';
import { jsPDF } from "jspdf";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar/Scrollbar';
import CustomComplete from '../components/customComplete/CustomComplete';
import { Api, UploadFile } from '../webservices';

function JobDetail() {
  const styleClients = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleClients11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleClients1 = {
    height: "90%",
    position: 'absolute',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '45%', sm: '65%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const navigate = useNavigate();
  const locationData = useLocation();
  // const row = locationData.state?.row;
  const [row, setRow] = useState(locationData.state?.row || {});
  const _id = locationData.state?._id;
  const success = locationData.state?.success;

  console.log("=====row", row)

  const getJobDetails = () => {
    const body = {
      "Job_id": _id,
    }
    const token = localStorage.getItem('token');
    Api(`company/JobDetail`, 'POST', body, token).then((response) => {
      if (response.status === 200) {
        setRow(response?.data?.result)
        if (response.data.code === 200) {
          // setRow(response?.data?.result)
          // setResumeArry(response.data.data);
          // setResumeUrl(response.data.data[0].resumeUrl)
        }
      }
    })
      .catch((err) => { });
  };

  console.log("row", row)
  const [currentTab, setCurrentTab] = useState('1');
  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  const [openN, setOpenN] = useState(false);
  const openNote = () => {
    setOpenN(true);
  };
  const closeNote = () => {
    setOpenN(false);
  };

  const [openS, setOpenS] = useState(false);
  const openScreening = () => {
    setOpenS(true);
  };
  const closeScreening = () => {
    setOpenS(false);
  };

  const [openC, setOpenC] = useState(false);
  const openCompensation = () => {
    setOpenC(true);
  };
  const closeCompensation = () => {
    setOpenC(false);
  };

  const [openR, setOpenR] = useState(false);
  const openResume = () => {
    setOpenR(true);
  };
  const closeResume = () => {
    setOpenR(false);
  };

  console.log("row===>>>", row)

  const formattedText = row?.jobDescription
    ?.replace(/<\/p>|<\/li>/g, '\n\n')
    ?.replace(/<[^>]+>/g, '')
    ?.replace(/&nbsp;/g, '')
    ?.replace(/\s+/g, ' ')
    ?.trim();

  // console.log(formattedText);

  const stripHtmlTags = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  useEffect(() => {
    getSkills()
    if (success === "success") {
      getJobDetails()
    }
  }, [])

  const [tempskill, setTempskill] = useState([]);
  const [cityStateStyling, setCityStateStyling] = useState(false)

  const [addedSkill, setAddedSkill] = useState([])

  const getSkills = async () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_skills/${"other"}`, 'GET', '', token)
      .then((response) => {
        // console.log('=========getSkills======>>>>>>>', response.data);
        if (response.data.code === 200) {
          if (response.data.result.length !== 0) {
            response.data.result.map((item) => {
              return tempskill.push({ title: item.skillName });
            });

            setAddedSkill(tempskill)
            // console.log('===value skilll========', JSON.stringify(skill));
          } else {
            // setSkill([{ title: '' }]);
          }
        } else {
          toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const [data, setData] = useState([])
  const [inputExcel, setInputExcel] = useState([]);
  const [fileInputFiles, setFileInputFiles] = useState([]);
  const [circle, setCircle] = useState(false)

  const circleFn = () => {
    setCircle(true)
  }

  const circleFn1 = () => {
    setCircle(false)
  }
  const [parse, setParse] = useState(false);
  const parseOpen = () => setParse(true);
  const parseClose = () => setParse(false);

  const handleFileSelect = (e) => {
    const files = e.target.files;
    const fileList = Array.from(files);
    // console.log('files browse', fileList)
    // parseClose()
    setFileInputFiles(fileList);
    fileList.map((item) => uploadMulti(item))
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const fileList = Array.from(files);
    setFileInputFiles(fileList);
    fileList.map((item) => uploadMulti(item))
  };

  const uploadMulti = async (pdf) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', pdf);
    formData.append('directoryName', 'resume');
    UploadFile(`resume/upload_resume`, formData, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          parseClose()
          circleFn()
          // setParseRes(Response.data.filePath)
          ParseRes(Response.data.filePath)
          // console.log('=====404=gst===', Response.data.filePath);

        } else {
          // console.log('=====404=gst===', Response.data.message);
          toast.warn(Response.data.status, +'!');
        }
      } else {
        toast.warn('Error !');
      }
    });
  };

  const ParseRes = (parseres) => {
    const body = {
      "resumeUrl": parseres
    }
    const token = localStorage.getItem("token")
    Api('common/cv/data', 'POST', body, token).then((Response) => {
      // console.log("Response", Response)
      if (Response.status === 200) {

        if (Response.data.code === 403) {
          setCityStateStyling(true)
          setRow(Response.data.result);
          // getResume();
          circleFn1();
          navigate('/resumeDetail', {
            state: {
              addedSkill,
              cityStateStyling,
              row: Response.data.result,
              kTab: "Hide",
              // mtab: 'Detail',
              mtab: 'Action' || 'Detail',
              fTab: "submitted",
              hideClient: "client",
              jobId: row?.jobId,
              scrQauestions: row?.screeningQuestions


            },
          });
        } else if (Response.data.code === 200) {
          setRow(Response.data.result);
          // getResume();
          circleFn1();
          navigate('/resumeDetail', {
            state: {
              // addedSkill,
              row: Response.data.result,
              kTab: "Hide",
              // mtab: 'Detail',
              mtab: 'Action' || 'Detail',
              fTab: "submitted",
              hideClient: "client",
              jobId: row?.jobId,
              scrQauestions: row?.screeningQuestions

            },
          });
        } else {
          circleFn1();
          toast.warn("A resume with the same email already exists");
          setTimeout(() => {

            navigate('/resumeDetail', {
              state: {
                addedSkill,
                cityStateStyling,
                row: Response.data.result,
                kTab: "Hide",
                // mtab: 'Detail',
                mtab: 'Action' || 'Detail',
                fTab: "submitted",
                hideClient: "client",
                jobId: row?.jobId,
                scrQauestions: row?.screeningQuestions

              },
            });
          }, 1000)
          // alert("A")
          // toast.warn(Response.data.error);
          // getResume();
        }
      } else {
        toast.warn('Error!');
        circleFn1();
        // toast.warn(Response.data.error);
      }
    })

  }

  pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

  //   const handleDownload = (row) => {
  //   const docDefinition = {
  //     content: [
  //       { text: row?.endClientOrImpPartner || "", fontSize: 12, margin: [0, 0, 0, 5] },
  //       { text: `${row?.jobTitle} - ${row?.jobId} [ ${row?.altJobTitle?.join(", ")} ]`, bold: true, fontSize: 14, margin: [0, 0, 0, 5] },
  //       { text: row?.openings ? `${row?.openings} Vacancy : ${row?.jobType}` : "", margin: [0, 0, 0, 5] },
  //       { text: `Updated: ${moment(row?.createdAT)?.format("ll")}`, margin: [0, 0, 0, 5] },
  //       { text: `${row?.location || ""} Out Of Area Candidate : ${row?.outOfAreaCandidate || ""} Relocation Assistance : ${row?.relocationAssistance || ""} Amount : ${row?.relocationExpenses || ""}`, margin: [0, 0, 0, 10] },
  //       { text: row?.remote || "", margin: [0, 0, 0, 10] },

  //       { text: "Job Description:", bold: true, fontSize: 13, margin: [0, 0, 0, 5] },
  //       { text: stripHtmlTags(row?.jobDescription || ""), margin: [0, 0, 0, 10] },

  //       { text: `Minimum Years of Experience: ${row?.minExperience || ""} to ${row?.maxExperience || ""}`, margin: [0, 0, 0, 10] },

  //       { text: "Must Have Skills:", bold: true },
  //       { text: row?.skillWithExp?.length ? row?.skillWithExp.map((item) => `${item?.mustHaveSkill} ${item?.minExperience}`).join(", ") : "", margin: [0, 0, 0, 10] },

  //       { text: "Desired Skills:", bold: true },
  //       { text: row?.desiredSkillsWithExp?.length ? row?.desiredSkillsWithExp.map((item) => `${item?.desiredSkill} ${item?.minExperience}`).join(", ") : "", margin: [0, 0, 0, 10] },

  //       { text: "Education:", bold: true },
  //       { text: row?.degree?.length ? row?.degree.map((item) => `${item?.degree} ${item?.degreeRequired}`).join(", ") : "", margin: [0, 0, 0, 10] },

  //       { text: "Certification:", bold: true },
  //       { text: row?.certifications?.length ? row?.certifications.map((item) => `${item?.certification} ${item?.certificationRequired}`).join(", ") : "", margin: [0, 0, 0, 10] },
  //     ],
  //     defaultStyle: {
  //       fontSize: 11,
  //     },
  //   };

  //   pdfMake.createPdf(docDefinition).download(`${row?.jobTitle || "Job_Details"}.pdf`);
  // };


  // pdf-lib 
  // const formatJobDescription = (html) => {
  //   if (!html) return '';
  //   return html
  //     .replace(/<br\s*\/?>/gi, '\n')  // replace <br> with newline
  //     .replace(/<\/p>/gi, '\n\n')     // replace </p> with double newline
  //     .replace(/<[^>]+>/g, '')        // remove other HTML tags
  //     .trim();
  // };

  // Utility to draw wrapped text in PDF
  // const drawWrappedText = (page, text, x, y, maxWidth, font, size, lineHeight) => {
  //   const paragraphs = text.split('\n'); // split by newline
  //   let currentY = y;

  //   paragraphs.forEach((para) => {
  //     const words = para.split(' ');
  //     let line = '';
  //     words.forEach((word) => {
  //       const testLine = `${line}${word} `;
  //       const width = font.widthOfTextAtSize(testLine, size);
  //       if (width > maxWidth) {
  //         page.drawText(line, { x, y: currentY, font, size, color: rgb(0, 0, 0) });
  //         line = `${word} `;
  //         currentY -= lineHeight;
  //       } else {
  //         line = testLine;
  //       }
  //     });
  //     page.drawText(line, { x, y: currentY, font, size, color: rgb(0, 0, 0) });
  //     currentY -= lineHeight; // space between paragraphs
  //   });

  //   return currentY;
  // };

  // const handleDownload = async (row) => {
  //   const pdfDoc = await PDFDocument.create();
  //   const page = pdfDoc.addPage([600, 900]); 
  //   const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  //   let y = page.getHeight() - 50;

  //   const jobDesc = formatJobDescription(row?.jobDescription);

  //   const content = `
  // ${row?.endClientOrImpPartner || ''}
  // ${row?.jobTitle} - ${row?.jobId} [ ${row?.altJobTitle?.join(', ')} ]
  // ${row?.openings ? `${row?.openings} Vacancy : ${row?.jobType}` : ''}
  // Updated : ${moment(row?.createdAT)?.format('ll')}
  // ${row?.location || ''} Out Of Area Candidate : ${row?.outOfAreaCandidate || ''} Relocation Assistance : ${row?.relocationAssistance || ''} Amount : ${row?.relocationExpenses || ''}
  // ${row?.remote || ''}
  // Compensation : ${row?.compensationType === 'annual' ? `$ ${row?.annualMinCompensation} K - $ ${row?.annualMaxCompensation} K` : ''}
  // ${row.compensationType === 'per hour' ? `$ ${row?.payRateOn.minPayRate} P/H - $ ${row?.payRateOn.maxPayRate} P/H` : ''}

  // Job Description:

  // ${jobDesc}

  // Minimum Years of Experience: ${row?.minExperience || ''} to ${row?.maxExperience || ''}
  // Must Have Skills: ${row?.skillWithExp?.length 
  //     ? row?.skillWithExp.map((item) => `${item?.mustHaveSkill} ${item?.minExperience}`).join(', ') 
  //     : ''}
  // Desired Skills: ${row?.desiredSkillsWithExp?.length 
  //     ? row?.desiredSkillsWithExp.map((item) => `${item?.desiredSkill} ${item?.minExperience}`).join(', ') 
  //     : ''}
  // Education: ${row?.degree?.length 
  //     ? row?.degree.map((item) => `${item?.degree} ${item?.degreeRequired}`).join(', ') 
  //     : ''}
  // Certification: ${row?.certifications?.length 
  //     ? row?.certifications.map((item) => `${item?.certification} ${item?.certificationRequired}`).join(', ') 
  //     : ''}
  // `;

  //   y = drawWrappedText(page, content, 50, y, 500, font, 12, 18);

  //   const pdfBytes = await pdfDoc.save();
  //   const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(blob);
  //   link.download = `${row?.jobTitle || 'Job_Details'}.pdf`;
  //   link.click();
  //   URL.revokeObjectURL(link.href);
  // };

  // const handleDownloadFromClipboard = async () => {
  //   const text = document.getElementById('jobDescPdfDown')?.innerText || '';

  //   console.log("text", text)
  //   const pdfDoc = await PDFDocument.create();
  //   const page = pdfDoc.addPage([600, 900]);
  //   const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  //   let y = page.getHeight() - 50;

  //   const lines = text.split();

  //   lines.forEach((line) => {
  //     page.drawText(line, { x: 50, y, size: 12, font, color: rgb(0, 0, 0) });
  //     y -= 18;
  //   });

  //   const pdfBytes = await pdfDoc.save();
  //   const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(blob);
  //   link.download = 'Job_Details.pdf';
  //   link.click();
  //   URL.revokeObjectURL(link.href);
  // };

  const text = document.getElementById('jobDescPdfDownload')?.innerText || '';
  console.log("text===", text)

  return (
    <>
      <ToastContainer />
      <Stack sx={{p:2, mt:-3}}> 

      <Iconify icon="ion:arrow-back" fontSize={25}
        sx={{ cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem', fontWeight: '600' }}
        onClick={() => navigate(-1)} />
      <Typography sx={{ color: 'text.secondary', fontSize: '1.6rem', mt:1, mb:1 }}>
        Job
      </Typography>
      <Stack sx={{ border: 2, borderColor: 'text.secondary', borderRadius: 2, p: 2 }}>
        <Stack sx={{ flexDirection: { xs: 'column', lg: 'row' }, width: '100%', mb: 2, gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            size="small"
            color="custom"
            sx={{ width: { xs: '100%', lg: "fit-content" }, height: 30, mt: 0.3 }}
            onClick={() => openNote()}
          >
            Recruiting Notes
          </Button>
          <Button
            variant="contained"
            size="small"
            color="custom"
            sx={{ width: { xs: '100%', lg: "fit-content" }, height: 30, mt: 0.3 }}
            onClick={() => openScreening()}
          >
            Screening Questions
          </Button>
          <Button
            variant="contained"
            size="medium"
            color="custom"
            sx={{ width: { xs: '100%', lg: "fit-content" }, height: 35 }}
            // onClick={() => setCurrentTab('1')}
            onClick={() => parseOpen()}
          >
            Submit Candidate
          </Button>
          <Button
            variant="contained"
            size="small"
            color="custom"
            sx={{ width: { xs: '100%', lg: "fit-content" }, height: 30, mt: 0.3 }}
            onClick={() => openCompensation()}
          >
            Compensation
          </Button>
          <Button
            variant="contained"
            size="small"
            color="custom"
            sx={{ width: { xs: '100%', lg: "fit-content" }, height: 30, mt: 0.3 }}
            onClick={() => openResume()}
          >
            Sample Resume
          </Button>
          {/* <Tabs
          value={currentTab}
          onChange={(event, newValue) => {setCurrentTab(newValue)}}
          aria-label="wrapped label tabs example"
        >
          <Tab
            value="1"
            label={
              <Stack flexDirection={'row'} gap={1} alignItems={'center'}>
                <Icon icon="fluent-mdl2:all-apps" fontSize={20} />
                <Typography>Job Detail</Typography>
              </Stack>
            }
          />
          <Tab
            value="2" 
             label={
              <Stack flexDirection={'row'} gap={1} alignItems={'center'}>
                <Icon icon="iconamoon:star-thin" fontSize={20} />
                <Typography>Screening Questions</Typography>
              </Stack>
            }
          />
          
          <Tab
            value="3"
            label={
              <Stack flexDirection={'row'} gap={1} alignItems={'center'}>
                <Icon icon="prime:dollar" fontSize={20} />
                <Typography>Compensation</Typography>
              </Stack>
            }
          />
          <Tab
            value="4"
            label={
              <Stack flexDirection={'row'} gap={1} alignItems={'center'}>
                <Icon icon="jam:triangle-danger" fontSize={20} />
                <Typography>Sample Resume</Typography>
              </Stack>
            }
          />
        </Tabs> */}
        </Stack>
        {currentTab === '1' && (
          <Stack sx={{ border: 2, borderColor: 'text.secondary', borderRadius: 2, p: 2 }}>
            <div id="jobDescPdfDown">
              <Typography sx={{ fontWeight: '600', textTransform: 'capitalize' }}>{row?.endClientOrImpPartner}</Typography>
              <Stack direction={'row'} gap={1} alignItems={'center'}>
                <Typography
                  sx={{ fontWeight: '600', cursor: 'pointer', textTransform: 'capitalize', fontSize: '0.9rem' }}
                  color={'text.secondary'}
                >
                  {row?.jobTitle} - {row?.jobId}
                </Typography>
                <Typography color={'text.textG'} sx={{ textTransform: 'capitalize' }}>
                  [ {row?.altJobTitle?.join(' | ')} ]
                </Typography>
              </Stack>
              <Typography sx={{ textTransform: 'capitalize' }}>
                {row?.openings} Openings : {row?.jobType}
              </Typography>
              <Stack direction={'row'} gap={1} alignItems={'center'}>
                <Typography>Updated : </Typography>
                <Typography sx={{ color: 'text.secondary' }}>{moment(row?.createdAT).format('ll')}</Typography>
              </Stack>
              <Stack direction={{ xs: 'column', lg: "row" }} gap={{ xs: 0, lg: 3 }} alignItems={{ xs: 'flex-start', lg: "center" }}>
                {/* <Typography sx={{ fontWeight: '600', color: 'text.secondary' }}>{row?.location}</Typography> */}
                <Typography sx={{ fontWeight: '600', color: 'text.secondary' }}>{row?.city}{", "}{row?.stateCode}</Typography>
                <Stack direction={'row'} gap={1} alignItems={'center'}>
                  <Typography sx={{ fontWeight: '600' }}>Out Of Area Candidate : </Typography>
                  <Typography sx={{ textTransform: 'capitalize' }}>{row?.outOfAreaCandidate}</Typography>
                </Stack>
                <Stack direction={'row'} gap={1} alignItems={'center'}>
                  <Typography sx={{ fontWeight: '600' }}>Relocation Assistance :</Typography>
                  <Typography sx={{ textTransform: 'capitalize' }}>{row?.relocationAssistance}</Typography>
                </Stack>
                <Stack direction={'row'} gap={1} alignItems={'center'}>
                  <Typography sx={{ fontWeight: '600' }}>Amount :</Typography>
                  <Typography>${row?.relocationExpenses}K</Typography>
                </Stack>
              </Stack>
              <Typography sx={{ textTransform: 'capitalize' }}>{row?.remote}</Typography>
              <Typography sx={{ fontWeight: '600', textTransform: 'capitalize' }}>Compensation</Typography>
              {row?.compensationType === 'annual' && (
                <Typography>
                  ${row?.annualMinCompensation}K - ${row?.annualMaxCompensation}K
                </Typography>
              )}
              {row?.compensationType === 'per hour' && (
                <>
                  <Typography>
                    Pay Rate on  W2 / T4 : ${row?.payRateOn?.minPayRate} P/H - ${row?.payRateOn?.maxPayRate} P/H
                  </Typography>
                  <Typography>
                    Pay Rate on C2C/1099/Inc : ${row?.onC2c1099Inc?.minC2c1099Inc} P/H - ${row?.onC2c1099Inc?.maxC2c1099Inc} P/H
                  </Typography>
                </>
              )}
              {row?.benefits?.length ? (
                <>
                  <Typography sx={{ fontWeight: '600', textTransform: 'capitalize' }}>Benefits</Typography>
                  <Typography sx={{ textTransform: 'capitalize' }}>{row?.benefits}</Typography>
                </>
              ) : null}
              <Typography sx={{ fontWeight: '600', mt: 2 }} color={'text.secondary'}>
                Job Description:
              </Typography>
              {/* <Typography>{row.jobDescription}</Typography> */}
              <div dangerouslySetInnerHTML={{ __html: row?.jobDescription }} />
              {/* <Typography sx={{ fontWeight: '600', mt: 2 }} color={''}>
            Duties/Responsibilities:
          </Typography>
          <Stack sx={{ p: 1 }}>
            <Typography>{row.recruitingInst}</Typography>
          </Stack>
          <Typography sx={{ fontWeight: '600', mt: 2 }} color={''}>
            Required Skills/Abilities::
          </Typography>
          <Stack sx={{ p: 1 }}>
            <Typography>
              Excellent Attention to Detail Excellent written and verbal communication skills. Excellent organizational
              and time management skills. Accounting background. Proficient in Microsoft Office Suite or similar
              software. Strong Excel skills Insurance Agency/Broker accounting Preferred Abilities: Knowledge of Applied
              TAM or EPIC a plus! Education and Experience: Bachelor’s degree in Accounting or Business Administration
              Five years or more of related experience work in accounting on the Broker/Agency Insurance industry in the
              absence of a related degree. Physical Requirements: Prolonged periods sitting at a desk and working on a
              computer.
            </Typography>
          </Stack> */}
              <Typography sx={{ fontWeight: '600', mt: 1 }} color={'text.secondary'}>
                Min/Max Years of Experience
              </Typography>
              <Stack direction="row" gap={2}>
                {row?.minExperience && row?.maxExperience && (
                  <Typography sx={{ textTransform: 'capitalize' }}>
                    Min: {row?.minExperience} to Max: {row?.maxExperience}
                  </Typography>
                )}
              </Stack>

              {row?.skillWithExp?.length > 0 && (
                <Stack>
                  <Typography sx={{ fontWeight: '600' }}>Must Have Skills:</Typography>
                  {row?.skillWithExp.map((item, index) => (
                    <Stack direction="row" gap={2} key={index}>
                      <Typography sx={{ textTransform: 'capitalize' }}>{item.mustHaveSkill}</Typography>
                      <Typography sx={{ textTransform: 'capitalize' }}>{item.minExperience}</Typography>
                    </Stack>
                  ))}
                </Stack>
              )}

              {row?.desiredSkillsWithExp?.length > 0 && (
                <Stack>
                  <Typography sx={{ fontWeight: '600' }}>Desired Skills:</Typography>
                  {row?.desiredSkillsWithExp?.map((item, index) => (
                    <Stack direction="row" gap={2} key={index}>
                      <Typography sx={{ textTransform: 'capitalize' }}>{item?.desiredSkill}</Typography>
                      <Typography sx={{ textTransform: 'capitalize' }}>{item?.minExperience}</Typography>
                    </Stack>
                  ))}
                </Stack>
              )}

              <Typography sx={{ fontWeight: '600', mt: 1 }} color={'text.secondary'}>
                Education:
              </Typography>
              <Stack sx={{}}>
                {row?.degree?.length > 0 && (
                  <Stack>
                    <Typography sx={{ fontWeight: '600', textTransform: 'capitalize' }}>degree</Typography>
                    {row?.degree?.length
                      ? row?.degree?.map((item) => {
                        return (
                          <Stack direction={'row'} gap={2}>
                            <Typography sx={{ textTransform: 'capitalize' }}>{item?.degree}</Typography>
                            <Typography sx={{ textTransform: 'capitalize' }}>{item?.degreeRequired}</Typography>
                          </Stack>
                        );
                      })
                      : null}
                  </Stack>
                )}
                {row?.certifications?.length > 0 && (
                  <Stack>
                    <Typography sx={{ fontWeight: '600', textTransform: 'capitalize', mt: 0.5 }}>certification</Typography>
                    {row?.certifications?.length
                      ? row?.certifications?.map((item) => {
                        return (
                          <Stack direction={'row'} gap={2}>
                            <Typography sx={{ textTransform: 'capitalize' }}>{item?.certification}</Typography>
                            <Typography sx={{ textTransform: 'capitalize' }}>{item?.certificationRequired}</Typography>
                          </Stack>
                        );
                      })
                      : null}
                    {/* <Typography sx={{ textTransform: 'capitalize' }}>
                {row.certifications ? row.certifications : '-'}
              </Typography>
              <Typography sx={{ textTransform: 'capitalize' }}>{row.certificationRequired}</Typography> */}
                  </Stack>
                )}
              </Stack>
              {/* <Stack sx={{ justifyContent: 'center', width: '100%', flexDirection: 'row' }}>
            <CopyToClipboard
              text={`
              ${row.endClientOrImpPartner}
              ${row.jobTitle} - ${row.jobId} [ ${row.altJobTitle.join(', ')} ]
              ${row.openings} Vacancy : ${row.jobType}
              Updated : ${moment(row.createdAT).format('ll')}
              ${row.location}Out Of Area Candidate : ${row.outOfAreaCandidate} Relocation Assistance : ${row.relocationAssistance} Amount : ${row.relocationExpenses}
              ${row.remote}
              Compensation : ${row.compensationType === 'annual' && (
                 `$ ${row.annualMinCompensation} K - $ ${row.annualMaxCompensation} K`
              )} 
              ${row.compensationType === 'per hour' && (
                `$ ${row.payRateOn.minPayRate} P/H - $ ${row.payRateOn.maxPayRate} P/H`
              )}
             
              Job Description: ${stripHtmlTags(row.jobDescription)}
              Minimum Years of Experience:  ${row.minExperience} to ${row.maxExperience}
              Must Have Skills: ${row.skillWithExp.length?row.skillWithExp.map((item, index) =>{
                return `${item.mustHaveSkill} ${item.minExperience}`
              }):null}
              Desired Skills: ${row.desiredSkillsWithExp.length?row.desiredSkillsWithExp.map((item, index) => {
                return `${item.desiredSkill} ${item.minExperience}`
              }):null}
              Education: ${row.degree.length
                ? row.degree.map((item) => {
                    return `${item.degree} ${item.degreeRequired}`
                  }):null}
              Certification:  ${row.certifications.length
                    ? row.certifications.map((item) => {
                        return `${item.certification} ${item.certificationRequired}`
                      }
                    ):null}`}
            >
              <Button variant="contained" size="small" color="custom" sx={{ width: 'fit-content' }}>
                Copy Description
              </Button>
            </CopyToClipboard>
          </Stack> */}

              {/* <Stack sx={{ justifyContent: 'center', width: '100%', flexDirection: 'row' }}>
              <CopyToClipboard
                text={`
      ${row.endClientOrImpPartner || ''}
      ${row.jobTitle} - ${row.jobId} [ ${row.altJobTitle.join(', ')} ]
      ${row.openings ? `${row.openings} Vacancy : ${row.jobType}` : ''}
      Updated : ${moment(row.createdAT).format('ll')}
      ${row.location || ''} Out Of Area Candidate : ${row.outOfAreaCandidate || ''} Relocation Assistance : ${row.relocationAssistance || ''} Amount : ${row.relocationExpenses || ''}
      ${row.remote || ''}
      Compensation : ${row.compensationType === 'annual' ? `$ ${row.annualMinCompensation} K - $ ${row.annualMaxCompensation} K` : ''}
      ${row.compensationType === 'per hour' ? `$ ${row.payRateOn.minPayRate} P/H - $ ${row.payRateOn.maxPayRate} P/H` : ''}
      Job Description: 

      ${stripHtmlTags(row.jobDescription || '')}

      Minimum Years of Experience: ${row.minExperience || ''} to ${row.maxExperience || ''}
      Must Have Skills: ${row.skillWithExp.length ? row.skillWithExp.map((item) => {
                  return `${item.mustHaveSkill} ${item.minExperience}`;
                }).join(', ') : ''}
      Desired Skills: ${row.desiredSkillsWithExp.length ? row.desiredSkillsWithExp.map((item) => {
                  return `${item.desiredSkill} ${item.minExperience}`;
                }).join(', ') : ''}
      Education: ${row.degree.length ? row.degree.map((item) => {
                  return `${item.degree} ${item.degreeRequired}`;
                }).join(', ') : ''}
      Certification: ${row.certifications.length ? row.certifications.map((item) => {
                  return `${item.certification} ${item.certificationRequired}`;
                }).join(', ') : ''}
    `}
                 
              > 
              
              </CopyToClipboard>
            </Stack>
  */}

              <Stack sx={{ justifyContent: 'center', width: '100%', flexDirection: 'row' }}>
                <div id="jobDescPdfDownload">
                  <CopyToClipboard
                    text={`
      ${row?.endClientOrImpPartner || ''}
      ${row?.jobTitle} - ${row?.jobId} [ ${row?.altJobTitle?.join(', ')} ]
      ${row?.openings ? `${row?.openings} Vacancy : ${row?.jobType}` : ''}
      Updated : ${moment(row?.createdAT)?.format('ll')}
      ${row?.location || ''} Out Of Area Candidate : ${row?.outOfAreaCandidate || ''} Relocation Assistance : ${row?.relocationAssistance || ''} Amount : ${row?.relocationExpenses || ''}
      ${row?.remote || ''}
      Compensation : ${row?.compensationType === 'annual' ? `$ ${row?.annualMinCompensation} K - $ ${row?.annualMaxCompensation} K` : ''}
      ${row.compensationType === 'per hour' ? `$ ${row?.payRateOn.minPayRate} P/H - $ ${row?.payRateOn.maxPayRate} P/H` : ''}
      Job Description: 

      ${stripHtmlTags(row?.jobDescription || '')}

      Minimum Years of Experience: ${row?.minExperience || ''} to ${row?.maxExperience || ''}
      Must Have Skills: ${row?.skillWithExp?.length ? row?.skillWithExp?.map((item) => {
                      return `${item?.mustHaveSkill} ${item?.minExperience}`;
                    }).join(', ') : ''}
      Desired Skills: ${row?.desiredSkillsWithExp?.length ? row?.desiredSkillsWithExp?.map((item) => {
                      return `${item?.desiredSkill} ${item?.minExperience}`;
                    }).join(', ') : ''}
      Education: ${row?.degree?.length ? row?.degree?.map((item) => {
                      return `${item?.degree} ${item?.degreeRequired}`;
                    }).join(', ') : ''}
      Certification: ${row?.certifications?.length ? row?.certifications?.map((item) => {
                      return `${item?.certification} ${item?.certificationRequired}`;
                    }).join(', ') : ''}
    `}
                  >
                    <span />
                  </CopyToClipboard>
                </div>

              </Stack>
              {/* <button onClick={() => handleDownloadFromClipboard()}>Download PDF</button> */}
            </div>
          </Stack>
        )}
        {currentTab === '2' && (
          <Stack sx={{ border: 1, borderColor: 'text.secondary', borderRadius: 1, p: 1 }}>
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
              Screening Questions
            </Typography>
            <Typography>{row?.screeningQuestions ? row?.screeningQuestions : '-'}</Typography>
          </Stack>
        )}
        {currentTab === '3' && (
          <Stack sx={{ border: 1, borderColor: 'text.secondary', borderRadius: 1, p: 1 }}>
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
              Compensation
            </Typography>
            {row?.compensationType === 'annual' && (
              <>
                <Typography sx={{ fontWeight: '600' }}>Annual Compensation</Typography>

                <Typography>
                  ${row?.annualMinCompensation}K - ${row?.annualMaxCompensation}K
                </Typography>
              </>
            )}
            {row?.compensationType === 'per hour' && (
              <>
                <Typography sx={{ fontWeight: '600' }}>Pay Rate On</Typography>
                <Typography sx={{ p: 1 }}>
                  ${row?.payRateOn.minPayRate} P/H - ${row?.payRateOn?.maxPayRate} P/H
                </Typography>
                <Typography sx={{ fontWeight: '600' }}>On C2C 1099 Inc</Typography>
                <Typography sx={{ p: 1 }}>
                  ${row?.onC2c1099Inc?.minC2c1099Inc} P/H - ${row?.onC2c1099Inc?.maxPayRate} P/H
                </Typography>
                <Typography sx={{ fontWeight: '600' }}>Bill Rate</Typography>
                <Typography sx={{ p: 1 }}>
                  ${row?.billRate?.minBillRate} P/H - ${row?.billRate?.maxBillRate} P/H
                </Typography>
              </>
            )}
          </Stack>
        )}
        {currentTab === '4' && (
          <Stack sx={{ border: 1, borderColor: 'text.secondary', borderRadius: 1, p: 1 }}>
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
              Sample Resume
            </Typography>
            <iframe title="resume" src={suru + row?.sampleResume + lll} width="100%" height="650px" />
          </Stack>
        )}
        {currentTab === '5' && (
          <Stack sx={{ border: 1, borderColor: 'text.secondary', borderRadius: 1, p: 1 }}>
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
              Recruiting Notes
            </Typography>
            {/* <Typography>{row.notes ? row.notes : ''}</Typography> */}
            <div dangerouslySetInnerHTML={{ __html: row?.recruitingInst }} />
          </Stack>
        )}

        <Modal
          open={circle}
          // onClose={circleFn1}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            <h2 id="simple-modal-title">Parsing resume, Please wait...</h2>
            {/* <p id="simple-modal-description">Modal content goes here.</p> */}
            <Iconify icon="eos-icons:arrow-rotate" width="5rem" color="green" />
            <CircularProgress style={{ display: 'none', marginTop: '20px' }} />
          </div>
        </Modal>

        <Modal open={parse} onClose={parseClose}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '30%',
              backgroundColor: 'white',
              border: '4px solid #1E74B3',
              borderRadius: '13px',
              padding: '1rem',
              outline: 'none',
              height: 'auto'
            }}

          >
            <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
              <div
                style={{
                  border: '3px dashed #1E74B3',
                  padding: '10px',
                  borderRadius: '15px',
                  margin: '1rem',
                  textAlign: 'center',
                  color: '#1E74B3',
                  // width: '85%',
                  alignContent: 'center',
                  marginLeft: '20px'
                }}
              >
                <Typography variant="body1" fontWeight="bold" mb={1}>
                  Browse File
                </Typography>
                <input
                  id="file-upload"
                  type="file"
                  accept=".doc,.docx, application/pdf"
                  onChange={handleFileSelect}
                  style={{ display: 'none' }}

                />
              </div>
            </label>
            {/* {fileInputFiles.length > 0 && (
            <div>
              {fileInputFiles.map((file, index) => (
                <Typography key={index} variant="body1" sx={{ marginLeft: '20px' }}>
                  {file.name}
                </Typography>
              ))}
            </div>

          )} */}
            <div>
              <Typography
                variant="body1"
                fontWeight="bold"
                mb={1}
                style={{
                  textAlign: 'center',
                  color: '#1E74B3',
                }}
              >
                OR
              </Typography>

              <div
                style={{
                  border: '3px solid #1E74B3',
                  padding: '10px',
                  borderRadius: '15px',
                  margin: '1rem',
                  textAlign: 'center',
                  height: '200px',
                  color: '#1E74B3',
                  alignContent: 'center',

                }}
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
              >
                Drag & Drop to Upload File
              </div>
            </div>


            {fileInputFiles.length > 0 && (
              <div>
                {/* {/ <Typography variant="body1">Uploaded Files</Typography> /} */}
                {fileInputFiles.map((file, index) => (
                  <Typography key={index} variant="body1" sx={{ marginLeft: '20px' }}>{file.name}</Typography>
                ))}
              </div>
            )}

            {/* <label htmlFor="file-upload-excel" style={{ cursor: 'pointer' }}>
            <div
              style={{
                border: '3px dashed #1E74B3',
                padding: '10px',
                borderRadius: '15px',
                margin: '1rem',
                // justifyContent: 'center',
                // alignItems: 'center',
                textAlign: 'center',
                color: '#1E74B3',
                // width: '330px',
                marginLeft: '25',
                alignContent: 'center',
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1}>
                Browse Excel File
              </Typography>
              <input
                id="file-upload-excel"
                type="file"
                accept=".csv, .xlsx"
                onChange={handleFileSelectExcel}
                style={{ display: 'none' }}
                multiple
              />

            </div>
          </label>
          {inputExcel.length > 0 && (
            <div>
              {inputExcel.map((file, index) => (
                <Typography key={index} variant="body1" sx={{ marginLeft: '20px' }}>{file.name}</Typography>
              ))}
            </div>
          )} */}
            {/* <Typography color="custom" variant="body1" sx={{ marginLeft: "30%" }}>
            <a href="/assets/Parsing-Candidate.xlsx" download style={{ textDecoration: 'underline', color: '#1E74B3' }}>
              Download Excel Format
            </a>
          </Typography> */}

          </Box>
        </Modal>

        <Modal open={openN} onClose={closeNote} style={{ borderRadius: 10 }}>
          <Box sx={styleClients}>
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
              Recruiting Notes
            </Typography>
            <Divider />
            <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
              <Stack sx={{ border: 1, borderColor: 'text.secondary', borderRadius: 2, p: 2, mt: 2 }}>
                <Typography sx={{ fontWeight: '600' }}>Note</Typography>
                <div dangerouslySetInnerHTML={{ __html: row?.recruitingInst }} />
                <Typography sx={{ fontWeight: '600' }}>Benefits</Typography>
                <Typography sx={{}}>{row?.benefits || '-'}</Typography>
                <Typography sx={{ fontWeight: '600' }}>Gurantee Period</Typography>
                <Typography sx={{}}>{row?.guaranteePeriod}</Typography>
              </Stack>
            </Scrollbar>
          </Box>
        </Modal>
        <Modal open={openS} onClose={closeScreening} style={{ borderRadius: 10 }}>
          <Box sx={styleClients11}>
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
              Screening Questions
            </Typography>
            <Divider />
            <Stack sx={{ border: 1, borderColor: 'text.secondary', borderRadius: 2, p: 2, mt: 2 }}>
              <Scrollbar sx={{ maxHeight: '300px', scrollbarWidth: 'thin' }}>
                <div
                  dangerouslySetInnerHTML={{ __html: row?.screeningQuestions }}
                  style={{
                    lineHeight: '1.6',
                    fontSize: '1rem',
                    whiteSpace: 'pre-wrap',
                  }}
                />
              </Scrollbar>
            </Stack>
          </Box>
        </Modal>

        <Modal open={openC} onClose={closeCompensation} style={{ borderRadius: 10 }}>
          <Box sx={styleClients}>
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
              Compensation
            </Typography>
            <Divider />
            <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
              <Stack sx={{ border: 1, borderColor: 'text.secondary', borderRadius: 2, p: 2, mb: 1, mt: 2 }}>
                {row?.compensationType === 'annual' && (
                  <>
                    <Typography sx={{ fontWeight: '600' }}>Annual Compensation</Typography>

                    <Typography>
                      ${row?.annualMinCompensation} K - ${row?.annualMaxCompensation} K
                    </Typography>
                  </>
                )}
                {row?.compensationType === 'per hour' && (
                  <>
                    <Stack sx={{ flexDirection: 'row', gap: 1 }}>
                      <Typography sx={{ fontWeight: '600' }}>Bill Rate :</Typography>
                      <Typography sx={{}}>
                        ${row?.billRate.minBillRate} P/H - ${row?.billRate.maxBillRate} P/H
                      </Typography></Stack>
                    <Stack sx={{ flexDirection: 'row', gap: 1 }}>
                      <Typography sx={{ fontWeight: '600' }}>Pay Rate On  W2 / T4 :</Typography>
                      <Typography sx={{}}>
                        ${row?.payRateOn.minPayRate} P/H - ${row?.payRateOn.maxPayRate} P/H
                      </Typography></Stack>
                    <Stack sx={{ flexDirection: 'row', gap: 1 }}>
                      <Typography sx={{ fontWeight: '600' }}>On C2C / 1099 / Inc :</Typography>
                      <Typography sx={{}}>
                        ${row?.onC2c1099Inc?.minC2c1099Inc} P/H - ${row?.onC2c1099Inc?.maxC2c1099Inc} P/H
                      </Typography></Stack>

                  </>
                )}
                <Typography sx={{ textTransform: 'capitalize' }}>Relocation : {row?.relocationAssistance}</Typography>
                <Typography>Relocation Amount : ${row?.relocationExpenses}K</Typography>
                <Typography>Interview Expenses : {row?.interviwExpenses ? "Yes" : 'No'}</Typography>
                <Typography>Interview Amount : ${row?.interviwExpenses}K</Typography>
              </Stack>
            </Scrollbar>
          </Box>
        </Modal>
        <Modal open={openR} onClose={closeResume} style={{ borderRadius: 10 }}>
          <Box sx={[styleClients1]}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mt: -2.5 }}>
              <Typography variant="h6" sx={{
                textAlign: 'center', color: 'text.secondary', fontWeight: 'bold',
                flex: 1, mb: 1, mt: 1
              }}>
                Sample Resume
              </Typography>
              <a href={row?.sampleResume} download>
                <Iconify icon="mdi:download" width="1.3rem" color='text.secondary' />
              </a>
            </Box>
            <Scrollbar sx={{ height: "97%", Scrollbar: 'thin', border: '2px solid #3C6BA5', borderColor: 'text.secondary', borderRadius: 2 }}>
              {/* <Divider /> */}
              <Stack sx={{ p: 1.5 }}>
                <iframe title="resume" src={suru + row?.sampleResume + lll} width="100%" height="700px" />
              </Stack>
            </Scrollbar>
          </Box>
        </Modal>
      </Stack>
      </Stack>
    </>
  );
} 

export default JobDetail;
